<template>
    <div>
        <datatable-filter v-show="datatable.filterStatus"
                          @filter="filter"
                          @filterClear="filterClear">
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group :label="$t('club_name')">
                        <b-form-input v-model="datatable.queryParams.filter.name"/>
                    </b-form-group>
                </b-col>
            </b-row>
        </datatable-filter>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   :lineNumbers="false"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        />
    </div>
</template>

<script>
    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter'
    import Datatable from '@/components/datatable/Datatable'
    //Other

    //Service
    import StudentClubService from "@/services/StudentClubService"
    import qs from "qs";

    export default {
        props: {
            clubData: {
                type: Object,
            }
        },

        components: {
            DatatableFilter,
            Datatable

        },

        data() {
            return {
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('join'),
                                    class: 'ri-user-add-fill',
                                    callback: (row) => {
                                        this.joinClub(row)
                                    }
                                },
                            ]
                        },
                        {
                            label: this.toUpperCase('club_name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('foundation_at'),
                            field: "creation_date",
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('club_type'),
                            field: 'type',
                            formatFn: (row) => {
                                if (row === 'academic') {
                                    return this.$t('academic');
                                } else if (row === 'social_cultural') {
                                    return this.$t('social_cultural');
                                } else if (row === 'sporty') {
                                    return this.$t('sporty');
                                } else {
                                    return '';
                                }
                            },
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            }
        },

        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.selectedPresident = '';
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },

            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const params = { ...this.datatable.queryParams };

                if (params.filter.status) {
                    params.filter = {
                        ...params.filter,
                        status: params.filter.status === 'a' ? '1' : '0'
                    };
                }

                const config = {
                    params,
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return StudentClubService.clubList(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data;
                        this.datatable.total = response.data.pagination.total;
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },

            joinClub(row) {
                StudentClubService.joinClub(row.id).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                    this.$emit('onUpdated', true)
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }
        },

        created() {

        },

    }
</script>
